<template>
    <div class="pk-c-d">
        <div class="pkc-top">
            <div class="top-1">
                <span class="top-result" :class="['style'+getScoreText()]" v-if="finished"></span>
                <a class="url-text style1" target="_blank" :href="'http://' + fromUrl">{{fromUrl}}</a>
            </div>
            <img src="../../content/images/pk/pk.png" alt="pk">
            <div class="top-2">
                <span class="top-result" :class="['style'+getScoreText(1)]" v-if="finished"></span>
                <span class="top-loading" v-else>检测中</span>
                <a class="url-text style2" target="_blank" :href="'http://' + url">{{url}}</a>
            </div>
        </div>
        <div class="pkc-content">
            <div class="pkc-score1"><span>{{progressData.score}}</span>分</div>
            <div v-for="classify in getList" :key="classify._id" class="pkc-classify">
                <p class="pkc-title">{{classify.title}}</p>
                <div v-for="item in classify.children" :key="item._id" class="pkc-item">
                    <span class="pkc-t1" :class="[item.result ? 'success' : 'warning']">
                        {{item.result ? '得分' : '失分'}}
                    </span>
                    <p class="pkc-t2">{{item.title}}</p>
                    <span class="pkc-t3" :class="[item.toResult ? 'success' : 'warning']" v-html="switchResult(item)"></span>
                </div>
            </div>
            <div class="pkc-score2" v-if="finished"><span>{{progress.score}}</span>分</div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
export default {
    props: ['from-url', 'url', 'progress', 'list', 'finished'],
    data() {
        return {
        }
    },
    computed: {
        ...mapState('check', ['progressData', 'classifyList', 'listData']),
        getList: function() {
            let list = _.cloneDeep(this.listData);
            list = _.map(list, item => {
                let item2 = _.find(this.list, {title: item.title}) || {};
                item.toResult = item2.result;
                return item;
            });
            if (!this.finished && this.list.length) {
                list[this.list.length - 1].isLast = true;
                list[this.list.length - 1].toResult = undefined;
            }
            return _.flatMap(_.cloneDeep(this.classifyList), classify => {
                classify.children = _.filter(list, {classify: classify.key});
                return classify.children.length ? classify : [];
            })
        }
    },
    methods: {
        switchResult(item) {
            if (_.isUndefined(item.toResult)) {
                return `<i class="x-icon icon-loading pkc-loading ${item.isLast ? 'active' : ''}"></i>`;
            } else {
                return item.toResult ? '得分' : '失分';
            }
        },
        getScoreText(type) {
            let fromScore = type ? this.progress.score : this.progressData.score;
            let toScore = type ? this.progressData.score : this.progress.score;
            if (fromScore > toScore) {
                return 1;
            } else if (fromScore === toScore) {
                return 2;
            } else {
                return 0;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .pk-c-d {
        padding-top: 4.5rem;
    }
    .pkc-top {
        width: 60rem;
        margin: 0 auto;
        padding-bottom: 2.5rem;
        border-bottom: 1px solid #1f1f20;
        white-space: nowrap;
        text-align: center;
        > * {
            display: inline-block;
            vertical-align: bottom;
        }
        .url-text {
            position: relative;
            display: block;
            width: 20.5rem;
            height: 1.5rem;
            line-height: 1.5rem;
            font-size: 1rem;
            color: #fff;
            background-color: #1f1f20;
            &:before, &:after {
                content: '';
                position: absolute;
                top: 0;
                border: .75rem solid transparent;
            }
            &.style1 {
                &:before {
                    left: 0;
                    border-left-color: #f1f1f1;
                }
                &:after {
                    left: 100%;
                    border-left-color: #1f1f20;
                }
            }
            &.style2 {
                &:before {
                    right: 100%;
                    border-right-color: #1f1f20;
                }
                &:after {
                    right: 0;
                    border-right-color: #f1f1f1;
                }
            }
        }
        img {
            width: 7rem;
            margin: 0 3.5rem;
        }
        @keyframes progress-text-animate {
            from {  background-position: 50% 0;  }
            to {  background-position: -100% 0;  }
        }
        .top-loading, .top-result {
            display: block;
            margin-bottom: 1.6rem;
        }
        .top-loading {
            font-size: 2.6rem;
            background-image: linear-gradient(to right, #2472e8 25%, #cdcdcd 25%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            -webkit-background-size: 200% 100%;
            animation: progress-text-animate 1s linear infinite;
        }
        .top-result {
            width: 100%;
            height: 5rem;
            background-repeat: no-repeat;
            background-size: auto 100%;
            background-position-x: center;
            &.style0 {
                background-image: url("../../content/images/pk/pk-0.png");
            }
            &.style1 {
                background-image: url("../../content/images/pk/pk-1.png");
            }
            &.style2 {
                background-image: url("../../content/images/pk/pk-2.png");
            }
        }
    }
    .pkc-content {
        position: relative;
        width: 53rem;
        margin: 0 auto;
        .pkc-score1, .pkc-score2 {
            position: absolute;
            top: 2.3rem;
            font-size: .9rem;
            span {
                font-size: 2.4rem;
            }
        }
        .pkc-score1 {
            left: -0.8rem;
        }
        .pkc-score2 {
            right: -0.8rem;
        }
        .pkc-classify {
            padding-top: 3.5rem;
        }
        .pkc-title {
            width: 10rem;
            font-size: 1.2rem;
            line-height: 2.1rem;
            margin: 0 auto;
            text-align: center;
            border-bottom: 1px solid #bebebe;
        }
        .pkc-item {
            position: relative;
            padding: 0 2.5rem;
        }
        .pkc-t1, .pkc-t3 {
            position: absolute;
            top: 0;
            font-size: .8rem;
        }
        .pkc-t1 {
            left: 0;
        }
        .pkc-t2 {
            font-size: 1rem;
        }
        .pkc-t3 {
            right: 0;
        }
    }
</style>
<style lang="scss">
    .pkc-loading {
        display: block;
        color: #bebebe;
        &.active {
            color: #1f1f20;
            animation: xw-rotating 1s linear infinite;
        }
    }
</style>



// WEBPACK FOOTER //
// app/view/detail/PKDetail.vue